module.exports = __webpack_public_path__ + "img/jiankangfuwu.53903d99.png";